import { render, staticRenderFns } from "./credit-applicant.vue?vue&type=template&id=7566f538&"
import script from "./credit-applicant.vue?vue&type=script&lang=ts&"
export * from "./credit-applicant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports